import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/medical-supply-request-form";

export const pagingMedicalSupplyRequestForm = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getMedicalSupplyRequestFormById = (medicalSupplyRequestFormId) => axios.get(API_PATH + "/get-by-id/" + medicalSupplyRequestFormId);

export const saveMedicalSupplyRequestForm = medicalSupplyRequestForm => axios.post(API_PATH + '/save-or-update', medicalSupplyRequestForm);

export const deleteMedicalSupplyRequestForm = medicalSupplyRequestFormId => axios.delete(API_PATH + '/mark-delete/' + medicalSupplyRequestFormId)
export const getAllMedicalSupplyRequestForm = () => axios.get(API_PATH + "/get-all");
